import { DownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {
	DishAssignmentContext,
	IDishAssignmentContext,
} from 'modules/Menu/Dishes/DishAssignment/dishAssignmentState/dishAssignmentContext';
import React, { useContext } from 'react';
import style from './SelectedOptionsButton.module.scss';

const SelectedOptionsButton: React.FC = () => {
	const { setShowBreadcrumbs, isShowBreadcrumbs, IDsSelectedCategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const iconClasses = classNames(style.icon, { [style.rotated]: isShowBreadcrumbs });

	const emptyCategories = !Object.keys(IDsSelectedCategories).length;

	const toggleShowBreadcrumbs = () => {
		setShowBreadcrumbs();
	};

	return (
		<Button
			data-test="SelectedOptionsButton"
			className={style.container}
			theme="outlinedPurple"
			iconPosition="post"
			disabled={emptyCategories}
			icon={<DownOutlined className={iconClasses} />}
			onClick={toggleShowBreadcrumbs}>
			<Text translationNameSpace="listing" translationKey="selectedOptionsLabel" asFragment={true} />
		</Button>
	);
};

export default SelectedOptionsButton;
